import React from 'react';
import FullPg from './FullPageT';
import { motion } from 'framer-motion';


export default function Glowna() {

    const pageVariants = {
        initial: {
            opacity: 0,
            backgroundColor: '#061e3d',
        },
        in: {
            opacity: 1,
            backgroundColor: '#061e3d',
        },
        out: {
            opacity: 0,
            backgroundColor: '#061e3d',
        },
    };

    const pageTransition = {
        type: 'tween',
        ease: 'anticipate',
        duration: 1.3,
    };

    return (
        <motion.div
            initial="initial"
            animate="in"
            exit="out"
            variants={pageVariants}
            transition={pageTransition}
        >
            <FullPg />
        </motion.div>
    )

}